import type { contacts as en } from "../en/contacts";
import type { Messages } from "../types";

export const contacts: Messages<typeof en> = {
  title: "جهات الاتصال",
  description: "كل من علّق أو راسلك، بملف واحد للشخص عبر كل القنوات.",
  search: "ابحث بالاسم أو المعرّف أو الوسم",
  allTags: "الكل",
  count: "{{n}} جهة اتصال",
  columns: {
    name: "الاسم",
    identities: "القنوات",
    tags: "الوسوم",
    firstSeen: "أول ظهور",
    lastSeen: "آخر نشاط",
  },
  empty: "لا توجد جهات اتصال بعد",
  emptyHint: "يظهر الأشخاص هنا عندما يعلّقون على منشوراتك أو يراسلونك.",
  noResults: "لا توجد نتائج مطابقة",
  noResultsHint: "جرّب اسماً أو معرّفاً أو وسماً آخر.",
  loadMore: "تحميل المزيد",
  profile: {
    back: "كل جهات الاتصال",
    identities: "الهويات",
    identitiesHint: "الشخص نفسه عبر القنوات المختلفة.",
    activity: "النشاط",
    activityHint: "التعليقات والمحادثات مع هذا الشخص.",
    noActivity: "لا يوجد نشاط بعد",
    comments: "التعليقات",
    conversations: "المحادثات",
    sentiment: "المشاعر",
    tags: "الوسوم",
    tagsLocal: "الوسوم التي تضيفها هنا تبقى على هذا الجهاز إلى أن يدعم الخادم تعديلها.",
    addTag: "أضف وسماً…",
    openInInbox: "افتح في الوارد",
    firstSeen: "أول ظهور",
    lastSeen: "آخر نشاط",
    comment: "تعليق",
    dm: "رسالة مباشرة",
    onPost: "على منشور",
    notFound: "جهة الاتصال هذه غير موجودة",
  },
};
